/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditGroupHasMaxDaysRestrictionApiRequest } from '../../models/hotel-edit-group-has-max-days-restriction-api-request';

export interface ApiHotelManageEditGroupMaxdaysRestrictionPost$Params {
      body: HotelEditGroupHasMaxDaysRestrictionApiRequest
}

export function apiHotelManageEditGroupMaxdaysRestrictionPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditGroupMaxdaysRestrictionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditGroupMaxdaysRestrictionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditGroupMaxdaysRestrictionPost.PATH = '/api/hotel/manage/edit/group/maxdays-restriction';
